import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Button, Container, CssBaseline } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "typeface-roboto";
import { SnackbarProvider } from "notistack";
import { AppTheme } from "./App.style";
import { Routes } from "./App.routes";
import { ConfirmationProvider } from "../../hooks/useConfirmation/useConfirmation";
import { GlobalStateProvider } from "../contexts/GlobalStateProvider";
import { DialogProvider } from "../../hooks/useDialog/useDialog";

const App: React.FC = () => {
  const providerRef = React.createRef<SnackbarProvider>();
  return (
    <GlobalStateProvider>
      <SnackbarProvider>
        <ThemeProvider theme={AppTheme}>
          <CssBaseline />
          <Container maxWidth="sm">
            <DialogProvider>
              <ConfirmationProvider>
                <SnackbarProvider
                  ref={providerRef}
                  maxSnack={5}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  action={(id) => (
                    <Button
                      onClick={() => providerRef.current?.closeSnackbar(id)}
                    >
                      <CloseIcon />
                    </Button>
                  )}
                >
                  <BrowserRouter basename="/upload">
                    <Routes />
                  </BrowserRouter>
                </SnackbarProvider>
              </ConfirmationProvider>
            </DialogProvider>
          </Container>
        </ThemeProvider>
      </SnackbarProvider>
    </GlobalStateProvider>
  );
};

export default App;
